import { IconButton } from "@mui/material";
import { Box } from "@mui/system";
import UploadIcon from "@mui/icons-material/Upload";

export default function JsonFileConventer({ input, result, isFilled, sendFile }: any) {
  const STYLES = {
    root: {
      padding: "0.1rem 0",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      borderBottom: `1px solid ${isFilled ? "rgba(0, 0, 0, 0.87)" : "rgba(0, 0, 0, 0.42)"}`,
      button: {
        backgroundColor: "",
      },
      h4: {
        fontWeight: "400",
        fontSize: "1rem",
        margin: 0,
        color: "rgba(0, 0, 0, 0.6)",
      },
    },
  };

  const readJsonFile = (event: any) => {
    sendFile(event.target.files[0]);
    const file = event.currentTarget.files[0];
    const reader = new FileReader();
    reader.onload = (e: any) => {
      const contents = e.target.result;

      result(JSON.parse(contents));
    };
    reader.readAsText(file);
  };

  return (
    <Box sx={STYLES.root}>
      <h4>{input.name}. Click the button to upload json file</h4>
      <IconButton color={isFilled ? "primary" : "default"} aria-label="upload picture" component="label">
        <input onChange={readJsonFile} hidden accept=".json" type="file" />
        <UploadIcon />
      </IconButton>
    </Box>
  );
}
